// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f8c43bbe","483":"2e959355","498":"c0cbf81d","703":"4d5d7e91","787":"63151f49"}[chunkId] + ".chunk.js";
};